import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Search, Plus, Inbox, User } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";

export const MobileBottomNav = () => {
  const { user } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user) return;
    let active = true;
    const load = () => api.get("/notifications").then(({ data }) => active && setUnread(data.unread)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, [user]);

  if (loc.pathname.startsWith("/artikel/") || loc.pathname.startsWith("/kaufen/")) return null;
  const items = [
    { to: "/", label: "Home", icon: Home, testid: "bottomnav-home" },
    { to: "/suche", label: "Suchen", icon: Search, testid: "bottomnav-search" },
    { sell: true },
    { to: user ? "/nachrichten" : "/anmelden", label: "Inbox", icon: Inbox, testid: "bottomnav-messages", badge: unread },
    { to: user ? "/konto" : "/anmelden", label: "Profil", icon: User, testid: "bottomnav-profile" },
  ];
  return (
    <nav aria-label="Mobile Navigation" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-border shadow-[0_-2px_14px_rgba(0,0,0,0.05)] grid grid-cols-5 pb-[env(safe-area-inset-bottom)] h-[calc(3.5rem+env(safe-area-inset-bottom))]">
      {items.map((it, i) =>
        it.sell ? (
          <button key={i} data-testid="bottomnav-sell" aria-label="Artikel verkaufen"
            onClick={() => nav(user ? "/verkaufen" : "/anmelden")}
            className="relative flex flex-col items-center justify-end pb-[11px]">
            <span className="absolute -top-4 bg-accent text-white rounded-full w-11 h-11 flex items-center justify-center shadow-[0_4px_12px_rgba(255,107,53,0.35)] active:scale-95 transition-transform">
              <Plus className="w-5 h-5" />
            </span>
            <span className="text-[10px] font-semibold text-accent leading-none">Verkaufen</span>
          </button>
        ) : (
          <Link key={i} to={it.to} data-testid={it.testid}
            className={`relative flex flex-col items-center justify-center gap-1 text-[10px] leading-none transition-colors ${loc.pathname === it.to ? "text-accent font-semibold" : "text-muted-foreground font-medium"}`}>
            <span className="relative">
              <it.icon className="w-5 h-5" strokeWidth={loc.pathname === it.to ? 2.2 : 1.8} />
              {it.badge > 0 && <span data-testid="bottomnav-unread-badge" className="absolute -top-1 -right-1.5 bg-accent text-white text-[8px] font-bold rounded-full min-w-[13px] h-[13px] flex items-center justify-center px-0.5">{it.badge}</span>}
            </span>
            {it.label}
          </Link>
        )
      )}
    </nav>
  );
};
